"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPromoCodeActivity = exports.getActivityByKey = exports.redeemCodeRedemption = exports.getActivityWithFreqCap = exports.getBonusCampaign = exports.getActivity = exports.dismissDailyBonus = exports.fetchActivityWithFrecCap = exports.credit = exports.fetchActivity = exports.fetchHomePageBonus = exports.fetchHomePageFeaturedActivity = exports.fetchShortListActivities = exports.fetchHomePageUserFeaturedActivity = exports.fetchHomePageUserActivities = exports.fetchUserActivities = exports.fetchActivities = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/activity/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var moment_1 = __importDefault(require("moment"));
var constants_1 = __importDefault(require("../../../config/constants"));
var action_type_util_1 = require("../../../redux/action-type.util");
var actions_1 = require("../../../redux/reducers/ledger/actions");
var fetchActivities = function (featured) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.ActivityService.getActivities(false, featured)];
            case 1:
                data = _a.sent();
                return [2, data];
            case 2:
                e_1 = _a.sent();
                console.error(e_1);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.fetchActivities = fetchActivities;
var fetchUserActivities = function (featured) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.ActivityService.getUserActivities(false, featured)];
            case 1:
                data = _a.sent();
                return [2, data];
            case 2:
                e_2 = _a.sent();
                console.error(e_2);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.fetchUserActivities = fetchUserActivities;
var fetchHomePageUserActivities = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: types_1.GET_ACTIVITY_LIST_V2,
                payload: services_1.ActivityService.getUserActivities(false, false, false)
            });
        }
        catch (error) {
            dispatch({
                type: (0, action_type_util_1.FAILURE)(types_1.GET_ACTIVITY_LIST_V2),
                payload: error
            });
            console.error(error);
        }
        return [2];
    });
}); }; };
exports.fetchHomePageUserActivities = fetchHomePageUserActivities;
var fetchHomePageUserFeaturedActivity = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: types_1.GET_ACTIVITY_FEATURED,
                payload: services_1.ActivityService.getUserActivities(false, true)
            });
        }
        catch (error) {
            dispatch({
                type: (0, action_type_util_1.FAILURE)(types_1.GET_ACTIVITY_FEATURED),
                payload: error
            });
            console.error(error);
        }
        return [2];
    });
}); }; };
exports.fetchHomePageUserFeaturedActivity = fetchHomePageUserFeaturedActivity;
var fetchShortListActivities = function (featured) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: (0, action_type_util_1.REQUEST)(types_1.GET_ACTIVITY_LIST_V2)
            });
            dispatch({
                type: types_1.GET_ACTIVITY_LIST_V2,
                payload: services_1.ActivityService.getActivities(false, featured, false)
            });
        }
        catch (error) {
            dispatch({
                type: (0, action_type_util_1.FAILURE)(types_1.GET_ACTIVITY_LIST_V2),
                payload: error
            });
            console.error(error);
        }
        return [2];
    });
}); }; };
exports.fetchShortListActivities = fetchShortListActivities;
var fetchHomePageFeaturedActivity = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: types_1.GET_ACTIVITY_FEATURED,
                payload: services_1.ActivityService.getActivities(false, true)
            });
        }
        catch (error) {
            dispatch({
                type: (0, action_type_util_1.FAILURE)(types_1.GET_ACTIVITY_FEATURED),
                payload: error
            });
            console.error(error);
        }
        return [2];
    });
}); }; };
exports.fetchHomePageFeaturedActivity = fetchHomePageFeaturedActivity;
var fetchHomePageBonus = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: types_1.GET_BONUS_ACTIVITY,
                payload: services_1.ActivityService.getActivities(false, false, true)
            });
        }
        catch (error) {
            dispatch({
                type: (0, action_type_util_1.FAILURE)(types_1.GET_BONUS_ACTIVITY),
                payload: error
            });
            console.error(error);
        }
        return [2];
    });
}); }; };
exports.fetchHomePageBonus = fetchHomePageBonus;
var fetchActivity = function (key, successCallback) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var activity, activities, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4, services_1.ActivityService.fetchActivity(key)];
                case 1:
                    activity = _b.sent();
                    activities = (_a = getState().activityState.activities) !== null && _a !== void 0 ? _a : {};
                    activities[activity.key] = activity;
                    return [4, dispatch({
                            type: (0, action_type_util_1.SUCCESS)(types_1.GET_ACTIVITY),
                            payload: { activities: activities }
                        })];
                case 2:
                    _b.sent();
                    successCallback(activity);
                    return [3, 4];
                case 3:
                    error_1 = _b.sent();
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.GET_ACTIVITY),
                        payload: error_1
                    });
                    console.error(error_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
};
exports.fetchActivity = fetchActivity;
var credit = function (key, onSuccess, onError) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var activity, activities, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4, services_1.ActivityService.credit(key)];
                case 1:
                    activity = _b.sent();
                    activities = (_a = getState().activityState.activities) !== null && _a !== void 0 ? _a : {};
                    activities[activity.key] = activity;
                    return [4, dispatch({
                            type: (0, action_type_util_1.SUCCESS)(types_1.CREDIT),
                            payload: { activities: activities }
                        })];
                case 2:
                    _b.sent();
                    dispatch((0, actions_1.fetchUserPoints)());
                    onSuccess();
                    return [3, 4];
                case 3:
                    error_2 = _b.sent();
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.CREDIT),
                        payload: error_2
                    });
                    console.error(error_2);
                    onError(error_2);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
};
exports.credit = credit;
var fetchActivityWithFrecCap = function (key) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var activity, activities, error_3;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4, services_1.ActivityService.fetchActivityWithFreqCap(key)];
            case 1:
                activity = _b.sent();
                activities = (_a = getState().activityState.activities) !== null && _a !== void 0 ? _a : {};
                activities[activity.key] = activity;
                return [4, dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_1.GET_ACTIVITY_WITH_FREQ_CAP),
                        payload: { activities: activities }
                    })];
            case 2:
                _b.sent();
                return [3, 4];
            case 3:
                error_3 = _b.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.GET_ACTIVITY_WITH_FREQ_CAP),
                    payload: error_3
                });
                console.error(error_3);
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.fetchActivityWithFrecCap = fetchActivityWithFrecCap;
var dismissDailyBonus = function (dismissed) {
    if (dismissed === void 0) { dismissed = true; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch({
                        type: types_1.DISMISS_DAILY_BONUS,
                        payload: {
                            dailyBonusRedemption: {
                                dismissed: dismissed,
                                dateDismissed: moment_1.default.now()
                            }
                        }
                    })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
};
exports.dismissDailyBonus = dismissDailyBonus;
var getActivity = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.ActivityService.getActivity(id)];
            case 1: return [2, _a.sent()];
            case 2:
                e_3 = _a.sent();
                console.error(e_3);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getActivity = getActivity;
var getBonusCampaign = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.ActivityService.getBonusCampaign(id)];
            case 1: return [2, _a.sent()];
            case 2:
                e_4 = _a.sent();
                console.error(e_4);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getBonusCampaign = getBonusCampaign;
var getActivityWithFreqCap = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.ActivityService.getActivityWithFreqCap(id)];
            case 1:
                data = _a.sent();
                if (data && data.frequencyCap && data.frequencyCap.length > 0) {
                    data.frequencyCap = data.frequencyCap[0];
                }
                return [2, data];
            case 2:
                e_5 = _a.sent();
                console.error(e_5);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getActivityWithFreqCap = getActivityWithFreqCap;
var redeemCodeRedemption = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.CodeRedemptionService.redeem(data)];
            case 1: return [2, _a.sent()];
            case 2:
                e_6 = _a.sent();
                console.error(e_6);
                return [2, e_6 === null || e_6 === void 0 ? void 0 : e_6.payload];
            case 3: return [2];
        }
    });
}); };
exports.redeemCodeRedemption = redeemCodeRedemption;
var getActivityByKey = function (activityKey, isLoggedIn) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, _a, e_7;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 6]);
                if (!isLoggedIn) return [3, 2];
                return [4, services_1.ActivityService.fetchActivityWithFreqCap(activityKey)];
            case 1:
                _a = _b.sent();
                return [3, 4];
            case 2: return [4, services_1.ActivityService.fetchActivity(activityKey)];
            case 3:
                _a = _b.sent();
                _b.label = 4;
            case 4:
                payload = _a;
                if (payload && payload.frequencyCap && payload.frequencyCap.length > 0) {
                    payload.frequencyCap = payload.frequencyCap[0];
                }
                return [2, payload];
            case 5:
                e_7 = _b.sent();
                console.error(e_7);
                return [3, 6];
            case 6: return [2];
        }
    });
}); };
exports.getActivityByKey = getActivityByKey;
var getPromoCodeActivity = function (isLoggedIn) { return __awaiter(void 0, void 0, void 0, function () {
    var e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, (0, exports.getActivityByKey)(constants_1.default.HOME_PROMO_CODE_ACTIVITY_KEY, isLoggedIn)];
            case 1: return [2, _a.sent()];
            case 2:
                e_8 = _a.sent();
                console.error(e_8);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getPromoCodeActivity = getPromoCodeActivity;
//# sourceMappingURL=actions.js.map